import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "triangle",
  "use": "triangle-usage",
  "viewBox": "0 0 22 26",
  "content": "<symbol viewBox=\"0 0 22 26\" xmlns=\"http://www.w3.org/2000/svg\" id=\"triangle\"><path d=\"M20 13.2427L1 2.24268V24.2427L20 13.2427Z\" stroke-width=\"2\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol